import React from 'react';
import { CreditCard } from 'lucide-react';

const PaymentsTab: React.FC = () => {
  return (
    <div className="w-full relative animate-fade-in text-center py-20 text-gray-500 border-2 border-dashed border-gray-800 rounded-xl">
      <CreditCard className="w-16 h-16 mx-auto mb-4 opacity-30" />
      <h2 className="text-xl font-bold text-gray-400">Płatności</h2>
      <p>Ta sekcja jest w budowie.</p>
    </div>
  );
};

export default PaymentsTab;
